import { useT } from "../../i18n";

// Each row: [cert, corp, motiv, gaia]
const VALUES = [
  ["—", "—", "—", "✓"],
  ["—", "✓", "—", "✓"],
  ["—", "—", "—", "✓"],
  ["✓", "—", "—", "✓"],
  ["✓", "—", "—", "✓"],
  ["—", "—", "—", "✓"],
];

const Mark = ({ v }) =>
  v === "✓" ? (
    <span className="check" aria-label="Yes">✓</span>
  ) : (
    <span className="cross" aria-label="No">—</span>
  );

export const Contrast = () => {
  const t = useT();
  const ROWS = t.contrast.rows;
  const COLS = t.contrast.cols;
  return (
    <section className="sp-section" data-testid="section-contrast">
      <div className="sp-container">
        <div className="sp-reveal">
          <span className="sp-eyebrow">{t.contrast.eyebrow}</span>
          <h2 className="sp-title">
            {t.contrast.titlePre}
            <em>{t.contrast.titleEm}</em>
            {t.contrast.titlePost}
          </h2>
          <p className="sp-lead">{t.contrast.lead}</p>
        </div>

        {/* Desktop / tablet: full table */}
        <div className="sp-contrast-table-wrap sp-reveal">
          <table className="sp-contrast-table" data-testid="contrast-table">
            <thead>
              <tr>
                <th>{t.contrast.capability}</th>
                <th>{COLS[0]}</th>
                <th>{COLS[1]}</th>
                <th>{COLS[2]}</th>
                <th className="col-gaia">{t.contrast.thisEngagement}</th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map((row, i) => (
                <tr key={row}>
                  <td>{row}</td>
                  <td><Mark v={VALUES[i][0]} /></td>
                  <td><Mark v={VALUES[i][1]} /></td>
                  <td><Mark v={VALUES[i][2]} /></td>
                  <td className="col-gaia"><Mark v={VALUES[i][3]} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile: stacked cards */}
        <div className="sp-contrast-cards sp-reveal" data-testid="contrast-cards">
          {ROWS.map((row, i) => (
            <div className="sp-contrast-card" key={row}>
              <h4>{row}</h4>
              <div className="sp-contrast-card-row">
                <span>{COLS[0]}</span>
                <Mark v={VALUES[i][0]} />
              </div>
              <div className="sp-contrast-card-row">
                <span>{COLS[1]}</span>
                <Mark v={VALUES[i][1]} />
              </div>
              <div className="sp-contrast-card-row">
                <span>{COLS[2]}</span>
                <Mark v={VALUES[i][2]} />
              </div>
              <div className="sp-contrast-card-row is-gaia">
                <span>{t.contrast.thisEngagement}</span>
                <Mark v={VALUES[i][3]} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
